export enum OrderStatesEnum {
    entered = 1,
    inWarehouse = 2,
    onTheWay = 3,
    inLocalWarehouse = 4,
    received = 5,
    inCustomsWarehouse = 6,
    inIntermediateWarehouse = 7,
    readyForShipment = 8,
    unidentified = 10,
    toBeDelivered = 12,
    readyForPickup = 13,
}